import React from "react";
import {
  Dialog,
} from "@mui/material";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import WarningAmberRoundedIcon from "@mui/icons-material/WarningAmberRounded";
import "../styles/dialog-premium.css";

interface ConfirmationDialogProps {
  open: boolean;
  title: string;
  message: string;
  cancelButtonName: string;
  confirmButtonName: string;
  onConfirm: () => void;
  onCancel: () => void;
}

const ConfirmationDialog: React.FC<ConfirmationDialogProps> = ({
  open,
  title,
  message,
  cancelButtonName,
  confirmButtonName,
  onConfirm,
  onCancel,
}) => {
  const isDestructive =
    confirmButtonName?.toLowerCase().includes("delete") ||
    confirmButtonName?.toLowerCase().includes("remove");

  return (
    <Dialog
      open={open}
      onClose={onCancel}
      className="premium-dialog-root confirmation-box"
      BackdropProps={{ className: "premium-modal-backdrop" }}
      PaperProps={{
        elevation: 0,
        className: "premium-dialog-paper",
      }}
    >
      <div className="premium-dialog-header">
        <h2 className="premium-dialog-title">{title}</h2>
        <button
          type="button"
          className="premium-dialog-close"
          onClick={onCancel}
          aria-label="close dialog"
        >
          <CloseRoundedIcon sx={{ fontSize: 18 }} />
        </button>
      </div>

      <div className="premium-dialog-body premium-dialog-body--with-icon">
        <div
          className={`premium-dialog-icon ${
            isDestructive
              ? "premium-dialog-icon--danger"
              : "premium-dialog-icon--warning"
          }`}
        >
          <WarningAmberRoundedIcon />
        </div>
        <div className="premium-dialog-content">
          <p className="premium-dialog-message">{message}</p>
        </div>
      </div>

      <div className="premium-dialog-footer">
        <button
          type="button"
          className="premium-dialog-btn premium-dialog-btn--cancel"
          onClick={onCancel}
        >
          {cancelButtonName}
        </button>
        <button
          type="button"
          className={`premium-dialog-btn ${
            isDestructive
              ? "premium-dialog-btn--danger"
              : "premium-dialog-btn--confirm"
          }`}
          onClick={onConfirm}
        >
          {confirmButtonName}
        </button>
      </div>
    </Dialog>
  );
};

export default ConfirmationDialog;
